import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { downArrowChevronIcon } from "../../../constants/icons";
import { calendarModuleName } from '../../../constants/config';

function DatePicker({
  year = null,
  month = null,
  day = null,
  onChange = () => {},
}) {
  const { t, i18n } = useTranslation(calendarModuleName);
  const [selectedDate, setSelectedDate] = React.useState(
    new Date(year, month - 1, day)
  );

  useEffect(() => {
    if (year !== null && month !== null && day !== null) {
      setSelectedDate(new Date(year, month - 1, day));
    }
  }, [year, month, day]);

  const handleDateChange = (newValue) => {
    if (!newValue || isNaN(newValue)) return;
    
    setSelectedDate(newValue);
    onChange(
      `${newValue.getFullYear()}-${ 
        String(newValue.getMonth() + 1).padStart(2, '0')}-${
        String(newValue.getDate()).padStart(2, '0')}`
    );
  };

  return (
    <div className="date-picker">
      <LocalizationProvider 
        dateAdapter={AdapterDateFns}
      >
        <MobileDatePicker
          value={selectedDate}
          onChange={handleDateChange}
          views={['year', 'month']}
          openTo="month"
          format="MMM yyyy"
          slotProps={{
            textField: {
              margin: 'normal',
              border: '0',
              sx: {
                '& .MuiOutlinedInput-root': {
                  padding: 0,
                  border: 0,
                  '& fieldset': { border: 'none' },
                  '&:hover fieldset': { border: 'none' },
                  '&.Mui-focused fieldset': { border: 'none' }
                }
              }
            },
            actionBar: {
              actions: ['cancel', 'accept'],
              translate: 'yes'
            },
            openPickerButton: {
              'aria-label': 'change date',
            }
          }}
          slots={{
            openPickerIcon: downArrowChevronIcon,
          }}
          reduceAnimations
          sx={{
            '& .MuiInputBase-root': { 
              // Add any custom styles here
            }
          }}
        />
      </LocalizationProvider>
    </div>
  );
}

export default React.memo(DatePicker);
